import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { Fragment, useState } from 'react';
import { useFormikContext } from 'formik';
import { ReleaseIdCard } from 'front-office/view-models/release-id-card';
import { AccordionGeneralityForm } from 'shell/view-models/accordion-generality-form';
import FormGenerality from 'shell/components/shared/form-generality/form';
import { headCells } from '../../constants';
import CitizenshipForm from 'shell/components/shared/citizenship-form';
import { CitizenshipVM } from 'shell/view-models/citizenship';
import { AccordionPersonForm } from 'shell/view-models/accordion-person-form';
import { noop } from 'shell/utils/noop';

const RegistryOfficeForm = (): React.ReactElement => {
  const formContext = useFormikContext<ReleaseIdCard>();

  const [openGenerality, setOpenGenerality] = useState(false);
  const [openCitizenship, setOpenCitizenship] = useState(false);

  const onAddToTable = useEventCallback((values: Array<CitizenshipVM>) => {
    const newRegistryOffice = {
      ...formContext.values.registryOffice,
      citizenship: values,
    };

    formContext.setFieldValue('registryOffice', newRegistryOffice);
  });

  const onDelete = useEventCallback((citizen: CitizenshipVM) => {
    const citizens = formContext.values.registryOffice?.citizenship?.slice() || [];

    const filteredCitizens = citizens.filter(
      (citizeToFilter: CitizenshipVM) => citizeToFilter.code !== citizen.code
    );

    const newRegistryOffice = {
      ...formContext.values.registryOffice,
      citizenship: filteredCitizens,
    };

    formContext.setFieldValue('registryOffice', newRegistryOffice);
  });

  return (
    <Fragment>
      <Accordion
        expanded={openGenerality}
        onChange={() => {
          setOpenGenerality(!openGenerality);
        }}
      >
        <AccordionSummary
          aria-controls="panel-person-content"
          id="panel-person-header"
          expandIcon={<ExpandMore />}
        >
          <Typography>Generalità</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FormGenerality
            onChangeGenerality={noop}
            onChangePerson={noop}
            onChangeFieldsPerson={noop}
            disabled
            person={formContext.values?.person as AccordionPersonForm}
            generality={formContext.values?.registryOffice?.generality as AccordionGeneralityForm}
            onChangeFieldsGenerality={noop}
          />
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={openCitizenship}
        onChange={() => {
          setOpenCitizenship(!openCitizenship);
        }}
      >
        <AccordionSummary
          aria-controls="panel-person-content"
          id="panel-person-header"
          expandIcon={<ExpandMore />}
        >
          <Typography>Cittadinanza</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <CitizenshipForm
            headCells={headCells}
            isEditMode={formContext.values.registryOffice?.isCitizenshipEditable || false}
            onAddToTable={onAddToTable}
            citizens={formContext.values.registryOffice?.citizenship as Array<CitizenshipVM>}
            onDelete={onDelete}
          />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

RegistryOfficeForm.displayName = 'Release id card form - registry office component';

export default RegistryOfficeForm;
